'use client';

import { FC } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import Button from '@/components/FormFields/Button';
import { HeadingThree, HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';
import useWebAlias from '@/helpers/hooks/useWebalias';

// import FoodImage from '../../../assets/images/food.webp';
// import SupplementsImage from '../../../assets/images/supplements.webp';
// import TreatsImage from '../../../assets/images/treats.webp';

interface SectionSolutionProps {
  solutions?: Array<string>;
}

const SectionSolutions: FC<SectionSolutionProps> = ({ solutions }) => {
  const { generateURL, webalias } = useWebAlias();
  return (
    <>
      <div className="relative z-[1] bg-section-solution pb-[9.375rem] sm:pt-[71px] md:pt-[8.5rem]">
        {/* <Image
          className="absolute -z-[1] sm:-bottom-[3%] lg:-bottom-[16%]"
          src={BackgroundImage}
          loading="lazy"
          alt="Background"
        /> */}
        <div className="mx-auto max-w-[67.5rem] text-center">
          <HeadingTwo className="mb-[23px] font-circular-std-medium sm:mx-[30px] lg:mx-0" variant="primary">
            Natural Uncompromising Solutions
          </HeadingTwo>
          <Paragraph className="m-auto mb-10 sm:mx-[30px] sm:w-auto lg:mx-auto lg:w-[80%]" variant="light-gray">
            Our products are developed by Veterinarians and PhDs in Animal Science and Pet Nutrition to ensure your fur
            baby thrives, not just survives from puppy and kitten stage to golden years.
          </Paragraph>
          <div className="grid grid-auto-fit-[17rem] sm:mx-[35px] sm:gap-[30px] lg:mx-2 lg:gap-10">
            <div>
              <div className="flex flex-col items-center rounded-[0.75rem] bg-white py-10 shadow-solution-card ">
                <HeadingThree className="font-circular-std-medium leading-10 sm:text-[30px] lg:text-[30px] xs:text-[30px] xxs:text-[30px]">
                  Supplements
                </HeadingThree>
                <Image
                  className="mt-4 h-[173px] w-auto  scale-150"
                  src={'https://imagedelivery.net/ErnLq8dzzMZmXNdJfHMsSg/79243fe2-84e9-47dd-654a-ee9775a27800/hd'}
                  loading="lazy"
                  alt="Supplements"
                  width={173}
                  height={173}
                  quality={100}
                />
                <Link href={generateURL('/products/980', webalias)}>
                  <Button
                    type="button"
                    className="mt-10 w-[12.5rem] px-[30px] py-[5px] text-[16px] leading-5"
                    variant="filled"
                    scheme="primary"
                  >
                    Shop Now!
                  </Button>
                </Link>
              </div>
            </div>
            <div>
              <div className="flex flex-col items-center rounded-[0.75rem] bg-white py-10 shadow-solution-card ">
                <HeadingThree className="font-circular-std-medium leading-10 sm:text-[30px] lg:text-[30px] xs:text-[30px] xxs:text-[30px]">
                  Treats
                </HeadingThree>
                <Image
                  className="mt-4 h-[173px] w-auto  scale-150"
                  src={'https://imagedelivery.net/ErnLq8dzzMZmXNdJfHMsSg/85a6ba18-7895-4fdb-2b4c-62fa670caa00/hd'}
                  alt="Treat"
                  height={173}
                  width={173}
                  quality={100}
                />
                <Link href={generateURL('/products/968', webalias)}>
                  <Button
                    type="button"
                    className="mt-10 w-[12.5rem] px-[30px] py-[5px] text-[16px] leading-5"
                    variant="filled"
                    scheme="primary"
                  >
                    Shop Now!
                  </Button>
                </Link>
              </div>
            </div>
            <div>
              <div className="flex flex-col items-center rounded-[0.75rem] bg-white py-10 shadow-solution-card ">
                <HeadingThree className="font-circular-std-medium leading-10 sm:text-[30px] lg:text-[30px] xs:text-[30px] xxs:text-[30px]">
                  Food
                </HeadingThree>
                <Image
                  className="mt-4 h-[173px] w-auto scale-150"
                  src={'https://imagedelivery.net/ErnLq8dzzMZmXNdJfHMsSg/0a0c034f-7a21-47ca-4c72-793eca4a0300/hd'}
                  loading="lazy"
                  alt="Food"
                  width={173}
                  height={173}
                  quality={100}
                />
                <Link href={generateURL('/products/983', webalias)}>
                  <Button
                    type="button"
                    className="mt-10 w-[12.5rem] px-[30px] py-[5px] text-[16px] leading-5"
                    variant="filled"
                    scheme="primary"
                  >
                    Shop Now!
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          {/* <article className="text-center sm:mt-[45px] lg:my-20">
            <HeadingTwo className="mb-[23px] font-circular-std-medium sm:mx-[30px] lg:mx-0">
              But Prevention Is The Key!
            </HeadingTwo>
            <Paragraph className="m-auto mb-10 sm:mx-[30px] sm:w-auto lg:mx-auto lg:w-[80%]" variant="light-gray">
              Avoid costly vet visits with purposeful supplementation that helps you address nearly 80%* of the top
              reason pet parents take their pets to the vet. With products developed with therapeutic levels of
              ingredients, we help pet parents address issues well before issues even occur!
            </Paragraph>

            <HeadingFour
              className="mt-[3.125rem] font-circular-std-medium sm:mx-[30px] sm:mb-[15px] sm:text-[17px] sm:leading-[27px] lg:mx-0 lg:mb-0 lg:text-[21px] lg:leading-8 xs:text-[17px] xxs:text-[17px]"
              variant="dark-gray"
            >
              From reactive to proactive, supplement today to avoid
              <br className="inline md:block" />
              issues tomorrow!
            </HeadingFour>
          </article> */}
        </div>
        {/* <div className="relative z-[1] -mb-[23.75rem] text-center">
          <Image src={ProductosImage} loading="lazy" width={700} alt="Productos" className="inline-block" />
          <Paragraph
            className="mt-[3.125rem] mb-0 sm:mx-[30px] sm:text-sm md:text-[0.75rem] lg:mx-0 lg:text-[0.8125rem] xs:text-sm xxs:text-sm"
            variant="secondary"
          >
            *77% of dog related issues. 63% of cat related issues. Source: Healthy Paws, Cost of Pet Health care Report,
            2019.
          </Paragraph>
        </div> */}
      </div>
      {/* <div className="min-h-[16.25rem] bg-section-solution"></div> */}
    </>
  );
};

export default SectionSolutions;
